
import '../../../src/global.css'
import {
  Box,
  Button,
  makeStyles,
  TextField,
  Typography,
  CircularProgress
} from '@material-ui/core'
import React, { useState } from 'react'
import ForwardIcon from '@material-ui/icons/Forward'
import { useAuth } from '@Hooks/useAuth'
import { CustomTheme } from '../../theme'
import { useGlobal } from '@Hooks/useGlobal'


const useStyles = makeStyles<CustomTheme, {}, string>((theme) => ({
  form: {
    '& > *': {
      margin: theme.spacing(1),
      width: '40ch',
      display: 'flex',
    },
    padding: '15px',
    //backgroundColor: 'rgba(0, 0, 0, 0.08)',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    minWidth: '100vw',
    backgroundColor: '#f5f5f5',
  },
  card: {
    display: 'flex',
    maxWidth: '800px',
    borderRadius: '8px',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  logo: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //backgroundColor: theme.custom.app_color,
    backgroundColor: '#000',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
}))

interface LoginProps {
  onSuccess: (username: string) => void
}


export default function Login({ onSuccess }: LoginProps) {
  const classes = useStyles()
  const { login, errors } = useAuth()
  const { wording } = useGlobal()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    setIsLoading(true)
    const target = e.target as typeof e.target & {
      username: { value: string }
      password: { value: string }
    }
    const loginResponse = await login({
      username: target.username.value,
      password: target.password.value,
    })


    if (loginResponse.status) {
      switch (loginResponse.type) {
        case 'by_pass':
          window.location.reload()
          break
        default:
          onSuccess(target.username.value)
          break
      }
    }
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)

  }
  return (
    <>
      <div className='login-main'>
        <div className={classes.container}>
          <Box>
            {/* <Box className={classes.logo}>
              <Typography style={{ color: '#fff' }} variant="h5">
                {wording['app_name']}
              </Typography>
            </Box> */}
            <Box className='logo-main-mirror'>
                <svg viewBox="0 0 177.354 35" ><g id="Group_42179" data-name="Group 42179" transform="translate(1032.788 18709.91)"><path id="Path_10903" data-name="Path 10903" d="M100,607.083V573.09h4.613l15.248,29.865.486,2.088h.583l.534-2.088,15.3-29.865h4.613v33.993h-2.768V575.13h-.583l-.825,3.253-14.763,28.7H118.89l-14.762-28.7-.826-3.253h-.534v31.953Z" transform="translate(-1132.788 -19283)"></path><rect id="Rectangle_7511" data-name="Rectangle 7511" width="2.768" height="33.993" transform="translate(-980.878 -18709.91)"></rect><path id="Path_10904" data-name="Path 10904" d="M177.744,591.738l1.166.68,12.965,14.665h-3.836L174.3,591.3h-6.264v15.783h-2.768V573.09H181c4.953,0,8.207,1.554,9.761,4.322a8.939,8.939,0,0,1,1.165,4.71,9.572,9.572,0,0,1-1.117,4.759c-1.6,2.817-5.1,4.274-10.149,4.274h-2.914Zm-9.712-16.074v13.16h12.674c3.837,0,6.265-1.02,7.479-3.06a7.285,7.285,0,0,0,.874-3.593,6.834,6.834,0,0,0-.826-3.448c-1.214-2.039-3.593-3.059-7.429-3.059Z" transform="translate(-1132.788 -19283)"></path><path id="Path_10905" data-name="Path 10905" d="M221.551,573.64l-2.015,5.909h-.6a3.532,3.532,0,0,0-2.35-.872c-3.425,0-4.7,1.41-14.237,20.481l-2.082,7.924h-4.23l7.387-27.8c.671-2.619-.336-3.627-3.358-3.157l-1.343.2.134-.672,10.275-2.484-5.977,22.966c9.133-19.609,12.558-22.966,16.251-22.966a5.418,5.418,0,0,1,2.149.47" transform="translate(-1132.788 -19283)"></path><path id="Path_10906" data-name="Path 10906" d="M219,598.285c0-9.2,7.789-25.115,19.676-25.115,4.566,0,9.6,2.35,9.6,9.8,0,9.2-7.79,25.116-19.676,25.116-4.567,0-9.6-2.351-9.6-9.805m24.242-15.915c0-6.783-2.35-8.193-4.969-8.193-8.126,0-14.237,13.7-14.237,24.713,0,6.782,2.351,8.192,4.97,8.192,8.125,0,14.236-13.7,14.236-24.712" transform="translate(-1132.788 -19283)"></path><path id="Path_10907" data-name="Path 10907" d="M277.354,573.64l-2.015,5.909h-.6a3.53,3.53,0,0,0-2.35-.872c-3.425,0-4.7,1.41-14.237,20.481l-2.082,7.924h-4.23l7.387-27.8c.671-2.619-.336-3.627-3.358-3.157l-1.343.2.134-.672,10.275-2.484-5.977,22.966c9.133-19.609,12.558-22.966,16.251-22.966a5.418,5.418,0,0,1,2.149.47" transform="translate(-1132.788 -19283)"></path></g></svg>
                <Typography style={{ color: '#fff' }} variant="h5">
                  {wording['app_name']}
                </Typography>
            </Box>
            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                id="username"
                name="username"
                label="Username"
                variant="outlined"
                size="small"
                fullWidth
              />
              <TextField
                id="password"
                name="password"
                label="Password"
                variant="outlined"
                size="small"
                type="password"
                fullWidth
              />
              <Button
                variant="contained"
                color="primary"
                endIcon={
                  isLoading ? <CircularProgress size={24} /> : <ForwardIcon />
                }
                disabled={isLoading}
  
                type="submit"
              >
                 {isLoading ? '' : 'Login'}
              </Button>
              <label style={{ color: 'red' }}>{errors?.message}</label>
            </form>
          </Box>
        </div>
      </div>
    </>
  )
}
